import { render, staticRenderFns } from "./phonogram-manager-form.vue?vue&type=template&id=0dcb77da&scoped=true"
import script from "./phonogram-manager-form.ts?vue&type=script&lang=ts&external"
export * from "./phonogram-manager-form.ts?vue&type=script&lang=ts&external"
import style0 from "./phonogram-manager-form.less?vue&type=style&index=0&id=0dcb77da&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcb77da",
  null
  
)

export default component.exports